import $ from 'jquery';
import slick from 'slick-carousel';


export default () => {


    let update_slider_progress = () => {
        let $current = $(".slick-track .slick-slide.slick-current").index() + 1;
        let $total = $(".slick-slide").length;
        
        // Update numbers
        $(".slider-paging [scope='current']").text($current);
        $(".slider-paging [scope='total']").text($total);

        // Update visual progress
        $('.visual-slider [scope="progress"]').addClass("go");
    };


    setTimeout(function(){
        // do it once at boot
        update_slider_progress();
    }, 500);
   
 
    if ($('.visual-slider').length > 0) {
        $('.visual-slider').each(function (i, elem) {
            // console.log('visual slider');
            if ($(window).width() <= 992) {
                $(elem).find('.slider-container .slide').each(function(i, slide) {
                    var mobile_src = $(slide).attr('data-url-mobile');
                    console.log(mobile_src)
                    $(slide).css("background-image", "url('" + mobile_src + "')");
                })
            }

            $(elem).find('.slider-container').slick({
                autoplay: true,
                autoplaySpeed: 7000,
                infinite: true,
                dots: false,
                arrows: true,
                prevArrow: $(elem).find('.arrow.arrow-left'),
                nextArrow: $(elem).find('.arrow.arrow-right'),
                adaptiveHeight: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: true,
                cssEase: 'linear', 
                pauseOnHover: false               
            });


            $(elem).on('beforeChange', (el, {slideCount: count }, currentSlide, nextSlide) => {                
                $('.visual-slider [scope="progress"]').removeClass("go");
                
                $($(".slick-track .slick-slide .slide").get(nextSlide)).addClass("go");
                setTimeout(() => {
                    $($(".slick-track .slick-slide .slide").get(currentSlide)).removeClass("go")
                }, 3000);
            });

            
            $(elem).on('afterChange', (el, {slideCount: count }, currentSlide, nextSlide) => {
                // Start animation
                // $(".slick-track .slick-slide .slide").removeClass("go");
                // $(".slick-track .slick-slide.slick-current .slide").addClass("go");

                // Update counter
                update_slider_progress();
            });
        });
    }
};



// WEBPACK FOOTER //
// ./scripts/libs/visual-slider.js